var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"siteHeader",staticClass:"site-header",class:[
    _vm.$store.state.nav.subNavIsOpen ? 'subnav-is-open' : '',
    _vm.beforeMount ? 'before-mounted' : '' ],attrs:{"data-hook":"header"}},[_c('DesktopNav'),_vm._v(" "),_c('MobileNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }